import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
	providedIn: 'root'
})
export class ToastrNotificationService {
	constructor(private toastr: ToastrService) {}

	showSuccess(message: string, title: string, options = {}) {
		this.toastr.success(message, title, options);
	}

	showError(message: string, title: string, options = {}) {
		this.toastr.error(message, title, options);
	}

	showInfo(message: string, title: string, options = {}) {
		this.toastr.info(message, title, options);
	}

	showWarning(message: string, title: string, options = {}) {
		this.toastr.warning(message, title, options);
	}
}
